// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import wysiwyg from 'vue-wysiwyg'
import '@/config/router.config'
import '@/config/element-ui'
import '@/assets/icons/style.css'
import '@/assets/styles/global.scss'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import Filter from '@/filters'
import vueDebounce from 'vue-debounce'

Vue.config.productionTip = false
moment.locale('es')
Vue.use(wysiwyg, {})
Vue.use(Filter)
Vue.use(vueDebounce)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js